import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SecurityService } from '@services/security.service';
import { GlobalAuthority } from '@app/shared/models/global-authority';

@Directive({ selector: '[appIsAuthorized]' })
export class IsAuthorizedDirective implements OnInit, OnDestroy {
  @Input('appIsAuthorized') public authority: GlobalAuthority;

  private readonly onDestroy$ = new Subject<void>();

  constructor(
    private readonly securityService: SecurityService,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef
  ) {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ngOnInit(): void {
    this.securityService
      .isAuthorized(this.authority)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((hasAuthority) => {
        if (!hasAuthority) {
          this.removeElement();
        }
      });
  }

  removeElement(): void {
    const parent = this.renderer.parentNode(this.el.nativeElement);
    this.renderer.removeChild(parent, this.el.nativeElement);
  }
}
